import InputNumber from 'rc-input-number';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SlideCard from '../../common/SlideCard';
import { setOperatorCommission } from '../../../store/actions/activation';
import { useRetailerType } from '../../../hooks/useRetailerType';

import styles from './OperatorCommissionSelector.module.scss';

export function OperatorCommissionSelector() {
  const { isDropship } = useRetailerType();
  const dispatch = useDispatch();
  const {
    loading: { commission: loading },
    supplierRetailer: { operator_commission: operatorCommission },
  } = useSelector((state) => state.activation);

  const [commissionValue, setCommissionValue] = useState(operatorCommission ?? 0);

  const updateCommission = () => {
    dispatch(setOperatorCommission(commissionValue));
  };

  if (isDropship) {
    return <SlideCard title="Commission" description="Prices are based on agreed wholesale prices"></SlideCard>;
  }

  return (
    <SlideCard
      title="Commission"
      description="Commission is a percentage of the final customer payment (excluding tax &amp; after discounts)"
    >
      <div className={styles.valueContainer}>
        <div className={styles.inputPercentage}>
          <InputNumber
            onChange={setCommissionValue}
            min={0}
            max={100}
            onBlur={(e) => {
              if (isNaN(e.target.value) || e.target.value === '') {
                setCommissionValue(0);
              }
            }}
            onFocus={(e) => e.target.select()}
            onClick={(e) => e.target.select()}
            value={commissionValue}
            step={1}
            precision={0}
            disabled={loading}
          />
          <span>%</span>
          <button type="button" disabled={loading} onClick={updateCommission}>
            {loading ? 'Saving' : 'Save'}
          </button>
        </div>
      </div>
    </SlideCard>
  );
}
